import React from "react";
import { round } from "@/3d/math";
import { InputNumber } from "@/dom/components/Input/Input";
import { Row } from "@/dom/components/Panel/Row";
import { Section } from "@/dom/components/Panel/Section";
import { useDemoState } from "@/state/demoState";

import css from "./RoomSizeSection.module.css";

import { useRoomSizeRestrictions } from "@/utils/useRoomSizeRestrictions";

export const RoomSizeSection: React.FC = () => {
    const roomConfig = useDemoState((state) => state.roomConfig);
    const setRoomConfig = useDemoState((state) => state.setRoomConfig);
    const roomSizeRestrictions = useRoomSizeRestrictions();

    const setRoomDimension = (dimension: "width" | "height" | "depth", value: number) => {
        let processedValue = value / 1000;
        if (processedValue < roomSizeRestrictions.min[dimension]) {
            processedValue = roomSizeRestrictions.min[dimension];
        } else if (processedValue > roomSizeRestrictions.max[dimension]) {
            processedValue = roomSizeRestrictions.max[dimension];
        }

        setRoomConfig({ ...roomConfig, [dimension]: round(processedValue) });

        return processedValue * 1000;
    };

    const area = round(roomConfig.width * roomConfig.depth, 2);

    return (
        <Section title="Размер комнаты" classNames={{ content: css.main }}>
            <Row>
                <span>Площадь комнаты (м2)</span>
                <span>{area}</span>
            </Row>
            <Row>
                <span>Длина комнаты (мм)</span>
                <InputNumber
                    value={roomConfig.depth * 1000}
                    onBlur={(value) => setRoomDimension("depth", value)}
                    step={100}
                    min={1000}
                    width="small"
                />
            </Row>
            <Row>
                <span>Ширина комнаты (мм)</span>
                <InputNumber
                    value={roomConfig.width * 1000}
                    onBlur={(value) => setRoomDimension("width", value)}
                    step={100}
                    min={1000}
                    width="small"
                />
            </Row>
            <Row>
                <span>Высота комнаты (мм)</span>
                <InputNumber
                    value={roomConfig.height * 1000}
                    onBlur={(value) => setRoomDimension("height", value)}
                    step={100}
                    min={1000}
                    width="small"
                />
            </Row>
        </Section>
    );
};
